import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface ModernLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  showTagline?: boolean;
  onClick?: () => void;
}

export const ModernLogo = ({
  className,
  size = "md",
  showTagline = false,
  onClick,
}: ModernLogoProps) => {
  const markSizeClasses = {
    sm: "h-9 w-9 rounded-lg",
    md: "h-11 w-11 rounded-xl",
    lg: "h-14 w-14 rounded-2xl",
  };

  const iconSizeClasses = {
    sm: "h-5 w-5",
    md: "h-6 w-6",
    lg: "h-8 w-8",
  };

  const textSizeClasses = {
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-3xl",
  };

  const taglineSizeClasses = {
    sm: "text-[10px]",
    md: "text-xs",
    lg: "text-sm",
  };

  const content = (
    <>
      <div
        className={cn(
          "flex items-center justify-center bg-primary shadow-sm shadow-primary/20",
          markSizeClasses[size]
        )}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={cn("text-primary-foreground", iconSizeClasses[size])}
          aria-hidden="true"
        >
          <path
            d="M16 8.5C16 7.11929 14.8807 6 13.5 6H10.5C8.01472 6 6 8.01472 6 10.5C6 11.8807 7.11929 13 8.5 13H11.5C13.9853 13 16 15.0147 16 17.5C16 18.8807 14.8807 20 13.5 20H10.5"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="flex flex-col leading-none">
        <span
          className={cn(
            "font-bold tracking-tight text-foreground",
            textSizeClasses[size]
          )}
        >
          Sortable
        </span>
        {showTagline && (
          <p
            className={cn(
              "text-muted-foreground/80 font-medium mt-1",
              taglineSizeClasses[size]
            )}
          >
            Trusted tradesmen
          </p>
        )}
      </div>
    </>
  );

  const baseClasses = cn(
    "flex items-center gap-2.5 transition-opacity hover:opacity-90 cursor-pointer relative z-10",
    className
  );

  if (onClick) {
    return (
      <button onClick={onClick} className={baseClasses} aria-label="Go to homepage">
        {content}
      </button>
    );
  }

  return (
    <Link to="/" className={baseClasses} aria-label="Go to homepage">
      {content}
    </Link>
  );
};
